import { MenuItem, MenuItemProps } from "@chakra-ui/react";

import { PropsWithChildren } from "react";

export interface FilterBarMenuItemProps
  extends PropsWithChildren<MenuItemProps> {}

export default function FilterBarMenuItem(props: FilterBarMenuItemProps) {
  return (
    <MenuItem
      w={{
        base: "xs",
        md: "full",
      }}
      {...props}
    />
  );
}
